import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Theme, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import react from "react";
import React from "react";
import { brightBlue, darkGrey } from "../../constants/colors";

export interface Props {
  onClose?: () => void;
  errorTitle?: string;
  errorContent?: string | react.ReactElement;
  btnText?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      color: "black",
      borderRadius: 12,
    },

    dialogTitle: {
      color: darkGrey,
    },

    button: {
      margin: 3,
      padding: 5,
      color: brightBlue,
    },
  });
});

export const ErrorAlert = ({ onClose, errorTitle, errorContent, btnText }: Props): React.JSX.Element => {
  const classes = useStyles();
  btnText = btnText || "Close";
  errorTitle = errorTitle || "Unknown Error";
  errorContent =
    errorContent || "something seems to be wrong. Please ensure you have entered all information correctly";
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={"sm"}
      aria-describedby="alert-dialog-description"
      PaperProps={{
        classes: {
          root: classes.root,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{errorTitle}</DialogTitle>
      <DialogContent>
        <Typography id="alert-dialog-description" className={classes.dialogTitle}>
          {errorContent}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button className={classes.button} variant="text" onClick={handleClose}>
          {btnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
